
<button (click)="openShedulesDial(); $event.stopPropagation()" [ngClass]="cssService.scheduleButton">
  <span>{{'includes.shedules-thumb.shedules' | translate}}</span>
</button>
